/** Compare semver-like version strings. Returns >0 if a>b, <0 if a<b, 0 if equal. */
export function compareVersions(a: string, b: string): number {
  const pa = parseParts(a)
  const pb = parseParts(b)
  const len = Math.max(pa.length, pb.length)
  for (let i = 0; i < len; i++) {
    const na = pa[i] ?? 0
    const nb = pb[i] ?? 0
    if (na !== nb) return na - nb
  }
  return 0
}

function parseParts(version: string): number[] {
  return version
    .replace(/^v/i, '')
    .split(/[.+_-]/)
    .map((p) => {
      const n = parseInt(p.replace(/\D/g, ''), 10)
      return Number.isFinite(n) ? n : 0
    })
}

export function isNewerVersion(latest: string, current: string): boolean {
  return compareVersions(latest, current) > 0
}

export function isNewerVersionCode(latestCode: number, currentCode: number): boolean {
  if (!Number.isFinite(latestCode) || !Number.isFinite(currentCode)) return false
  return latestCode > currentCode
}
